import React from "react";

import "./App.css";
import "./App.scss";
import { ConfigurationProvider } from "./app/context/configurationContext";

import Layout from "./app/layout/layout";
import RouterProtected from "./app/router/routerProtected";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme";
import { PrestadorProvider } from "./app/context/prestadorContext";
import { OnboardingProvider } from "./app/context/onboardingContext";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ConfigurationProvider>
        <OnboardingProvider>
          <PrestadorProvider>
            <RouterProtected>
              <Layout />
            </RouterProtected>
          </PrestadorProvider>
        </OnboardingProvider>
      </ConfigurationProvider>
    </ThemeProvider>
  );
}

export default App;
